// What this browser/device reports about itself on every login -- see
// nodeowner-auth-api-local's LoginRequest and auth.authusersession's own
// column comments for why: "Активные сессии" is a lot more useful showing
// "Веб, build a1b2c3d" than nothing at all. Ported from kwms-web's own
// clientInfo.ts.
const DEVICE_ID_KEY = "nodeowner.device_id";

/**
 * A UUID generated once per browser and persisted in localStorage --
 * distinguishes two different browsers/machines logged in as the same
 * authuser, which the session list alone can't. Not tied to any one
 * authuser -- shared across whoever logs in on this same browser, same as
 * the browser itself is shared.
 */
function getOrCreateDeviceId(): string {
  const existing = localStorage.getItem(DEVICE_ID_KEY);
  if (existing) return existing;
  const fresh = crypto.randomUUID();
  localStorage.setItem(DEVICE_ID_KEY, fresh);
  return fresh;
}

export interface ClientInfoFields {
  client_platform: string;
  client_version: string;
  client_device_id: string;
}

/** Spread this into the login request body. */
export function clientInfoFields(): ClientInfoFields {
  return {
    client_platform: "web",
    client_version: __APP_VERSION__,
    client_device_id: getOrCreateDeviceId(),
  };
}
